<template>
  <div>
    <v-tabs v-model="tabs" color="white" :slider-color="$store.state.theme.brand_color">
      <v-tab ripple :key="'member'" :href="'#member'">{{ $t('Member') }}</v-tab>
      <v-tab ripple :key="'branch'" :href="'#branch'">{{ $t('Branch') }}</v-tab>
      <v-tab ripple :key="'member-interaction'" :href="'#member-interaction'">{{
        $t('Member Interaction')
      }}</v-tab>
    </v-tabs>

    <div v-if="tabs == 'member'">
      <Member></Member>
    </div>
    <div v-if="tabs == 'branch'">
      <Branch></Branch>
    </div>
    <div v-if="tabs == 'member-interaction'">
      <MemberInteraction></MemberInteraction>
    </div>
  </div>
</template>

<script>
import Member from './Member.vue'
import Branch from './Branch.vue'
import MemberInteraction from './MemberInteraction.vue'
export default {
  components: {
    Member,
    Branch,
    MemberInteraction
  },
  data() {
    return {
      tabs: 'member'
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/grampablokof/main.vue